(function () {
  // Horizon theme: fix double-tap on category links in mobile/in-app browsers
  // The issue is Horizon's menu uses :hover CSS which mobile treats as first tap

  function fixHorizonTouchLinks() {
    // Target all navigation links in Horizon's menu components
    var selectors = [
      '.menu-list__link',
      '.mega-menu a',
      '.header-menu a',
      'nav a[href]',
      '.collection-list a',
      '.card-wrapper a'
    ];

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(link) {
        if (link.dataset.touchFixed) return; // avoid duplicate listeners
        link.dataset.touchFixed = 'true';

        link.addEventListener('touchend', function(e) {
          var href = link.getAttribute('href');
          if (href && href !== '#' && !href.startsWith('javascript')) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = href;
          }
        }, { passive: false });
      });
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHorizonTouchLinks);
  } else {
    fixHorizonTouchLinks();
  }

  // Also run after any dynamic content loads (Horizon uses web components)
  var observer = new MutationObserver(function() {
    fixHorizonTouchLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();